import axios from 'axios';
import constantsFactory from '@/utils/constants';
import {
  LOAD_SEARCH_AUTOCOMPLETE_REQUEST,
  LOAD_SEARCH_AUTOCOMPLETE_SUCCESS,
  LOAD_SEARCH_AUTOCOMPLETE_FAILURE,
  LOAD_ARTIST_SEARCH_AUTOCOMPLETE_SUCCESS,
  LOAD_ARTIST_SEARCH_AUTOCOMPLETE_FAILURE,
  LOAD_ARTIST_SEARCH_AUTOCOMPLETE_REQUEST,
} from '@/redux/actionTypes';

const {API} = constantsFactory();

export const getSearchAutocomplete = (keyWord, onSuccessCallbacks = []) => {
  return {
    types: [
      LOAD_SEARCH_AUTOCOMPLETE_REQUEST,
      LOAD_SEARCH_AUTOCOMPLETE_SUCCESS,
      LOAD_SEARCH_AUTOCOMPLETE_FAILURE,
    ],
    callAPI: () =>
      axios.get(`${process.env.HOST}${API.SEARCH}autocomplete/`, {
        params: {query: keyWord},
        headers: {Accept: 'application/json'},
        withCredentials: true,
      }),
    onSuccess: onSuccessCallbacks,
  };
};

export const getArtistSearchAutocomplete = (keyWord, onSuccessCallbacks = []) => {
  return {
    types: [
      LOAD_ARTIST_SEARCH_AUTOCOMPLETE_REQUEST,
      LOAD_ARTIST_SEARCH_AUTOCOMPLETE_SUCCESS,
      LOAD_ARTIST_SEARCH_AUTOCOMPLETE_FAILURE,
    ],
    callAPI: () =>
      axios.get(`${process.env.HOST}${API.SEARCH}artists/`, {
        params: {query: keyWord},
        headers: {Accept: 'application/json'},
        withCredentials: true,
      }),
    onSuccess: onSuccessCallbacks,
  };
};
